<template>
  <div>
    <div v-if="loading" class="d-flex align-items-center flex-column justify-content-center mt-4">
      <div>
        <div class="spinner-border spinner-class"></div>
      </div>
    </div>
    <div v-if="!loading">
      <div v-if="circleProviders.length === 0" class="text-center">
        <div class="dailogbox">
          <div class="dailog-wrapper">
            <span class="dailog">No one added yet</span>
            <span class="sub-dailog">You have not added anyone to your circle yet.</span>
            <a-button
              :style="{ background: getSecondaryColor(), 'pointer-events': 'all', 'font-size': '14px', 'border-radius': '6px', padding: '12px 24px' }"
              class="font-white primary-button profile-btn"
              @click="() => $router.push({ name: 'MeetOthers' })"
            >
              Search and Add
            </a-button>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="mb-2" v-for="doctor in circleProviders" :key="doctor.id">
          <div class="mb-2">
            <SelfProviderCard :info="doctor" :type="type" :isSelf="true" :fetchCircleProviders="fetchCircleProviders" @addVirtualDocToCircle="addVirtualDocToCircle($event, addType)" />
          </div>
        </div>
        <span v-if="circleProviders.length != totalCount" class="viewmore cp text-center" :style="{ color: getPrimaryColor(), display: 'block' }" @click="fetchCircleProviders(true)"> View More </span>
      </div>
    </div>
    <RecommendDoctorModal ref="recommendDoctorModal" />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { eventBus } from "../../../../main"
import RecommendDoctorModal from "../../../Modals/RecommendDoctor"
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import ProviderCard from "../../../home/provider/ProviderCard"
import SelfProviderCard from "../../../home/provider/selfProfiderCard"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "SelfCircleProviders",
  components: { RecommendDoctorModal, ProviderCard, SelfProviderCard },
  data() {
    return {
      loading: true,
      currentPage: 1,
      limit: 2,
      showNo: false,
      type: "",
      addType: "",
      circleProviders: [],
      displayType: "",
      name: "",
      circleData: {},
      clinic: [],
      doctor: [],
      nfp: [],
      hcp: [],
      hospital: [],
      doctorCount: 0,
      HospitalCount: 0,
      ClinicCount: 0,
      HcpCount: 0,
      NfpCount: 0,
      totalCount: 0,
    }
  },

  created() {
    console.warn("SelfProviders.vue is created")
    this.fetchCircleProviders()
  },

  computed: {
    ...mapGetters({ circleMembers: "Circle/circleMembers" }),
  },

  methods: {
    /**
     * Fetch self circle members
     */
    fetchCircleProviders(append = false) {
      this.loading = true
      UserRepository.getCircleProviders(this.authUser.user, this.currentCircle.id, this.currentPage, this.limit)
        .then(res => {
          if (res.data.data) {
            if (append) {
              this.doctor = this.doctor.concat(res.data.data.doctors.circle_doctors)
              this.doctor = this.doctor.concat(res.data.data.doctors.virtual_doctors)
              this.clinic = this.clinic.concat(res.data.data.clinics.circle_clinics)
              this.hospital = this.hospital.concat(res.data.data.hospitals.circle_hospitals)
              this.nfp = this.nfp.concat(res.data.data.nfps.circle_nfps)
              this.hcp = this.hcp.concat(res.data.data.hcps.circle_hcps)
              this.clinic = this.clinic.concat(res.data.data.clinics.virtual_clinics)
              this.hospital = this.hospital.concat(res.data.data.hospitals.virtual_hospitals)
              this.hcp = this.hcp.concat(res.data.data.hcps.virtual_hcps)
              this.nfp = this.nfp.concat(res.data.data.nfps.virtual_nfp)
            } else {
              this.doctor = res.data.data.doctors.circle_doctors ? res.data.data.doctors.circle_doctors : []
              this.doctor = this.doctor.concat(res.data.data.doctors.virtual_doctors)
              this.clinic = res.data.data.clinics.circle_clinics ? res.data.data.clinics.circle_clinics : []
              this.hospital = res.data.data.hospitals.circle_hospitals ? res.data.data.hospitals.circle_hospitals : []
              this.nfp = res.data.data.nfps.circle_nfps ? res.data.data.nfps.circle_nfps : []
              this.hcp = res.data.data.hcps.circle_hcps ? res.data.data.hcps.circle_hcps : []
              this.clinic = this.clinic.concat(res.data.data.clinics.virtual_clinics)
              this.hospital = this.hospital.concat(res.data.data.hospitals.virtual_hospitals)
              this.hcp = this.hcp.concat(res.data.data.hcps.virtual_hcps)
              this.nfp = this.nfp.concat(res.data.data.nfps.virtual_nfp)
            }
            this.DoctorCount = res.data.data.doctors.doctors_paginator.total_count
            this.HospitalCount = res.data.data.hospitals.hospitals_paginator.total_count
            this.ClinicCount = res.data.data.clinics.clinics_paginator.total_count
            this.HcpCount = res.data.data.hcps.hcps_paginator.total_count
            this.NfpCount = res.data.data.nfps.nfps_paginator.total_count
            this.currentPage = this.currentPage + 1
          }
          let r = this.$router.currentRoute.fullPath.split("/")
          switch (r[r.length - 1]) {
            case "providers": {
              this.circleProviders = this.doctor
              this.type = "providers"
              this.addType = "addprovider"
              this.displayType = "Doctors"
              this.totalCount = this.DoctorCount
              this.loading = false
              break
            }
            case "hospitals": {
              this.circleProviders = this.hospital
              this.type = "hospital"
              this.addType = "addhospital"
              this.displayType = "Hospitals"
              this.totalCount = this.HospitalCount
              this.loading = false
              break
            }
            case "clinics": {
              this.circleProviders = this.clinic
              this.type = "clinic"
              this.addType = "addclinic"
              this.displayType = "Clinics"
              this.totalCount = this.ClinicCount
              this.loading = false
              break
            }
            case "nfp": {
              this.circleProviders = this.nfp
              this.type = "nfp"
              this.addType = "addnfp"
              this.displayType = "Non for profits"
              this.totalCount = this.NfpCount
              this.loading = false
              break
            }
            case "hcp": {
              this.circleProviders = this.hcp
              this.type = "hcps"
              this.addType = ""
              this.displayType = "Other health care profesionals"
              this.totalCount = this.HcpCount
              this.loading = false
              break
            }
            default: {
              this.circleProviders = this.doctor
              this.type = "physician"
              this.addType = "addtocircle"
              this.displayType = "Physicans"
              this.totalCount = this.DoctorCount
              this.loading = false
              break
            }
          }
        })
        .catch(err => {})
    },

    /*
     * Add Member to Circle
     */
    addMemberToCircle(user) {
      UserRepository.addToCircle(user, this.currentCircle.id)
        .then(res => {
          // this.fetchCircleProviders()
          eventBus.$emit("refresh-circle-members")
        })
        .catch(err => {})
    },

    /**
     * View other user profile
     */
    viewProfile(user) {
      if (user.id === this.authUser.user.id) {
        this.routeToAuthProfile(this.authUser.user.role)
      } else {
        UserRepository.getOtherUserProfile(user, this.currentCircle.id)
          .then(res => {
            const data = {
              ...res.data.data.user_info,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add,
              recommendations: res.data.data.no_of_recommendations,
              recommend: res.data.data.recommend,
            }
            this.$store.commit("User/setViewUser", { data })
            switch (user.role) {
              case "doctor":
                this.$router.push({
                  name: "ViewDoctorUpdates",
                  params: { id: user.id },
                })
                break
              case "patient":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.id },
                })
                break
              case "caregiver":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.id, role: 'caregiver' },
                })
                break
              case "advocate":
                this.$router.push({
                  name: "ViewAdvocateUpdates",
                  params: { id: user.id },
                })
                break
              default:
                break
            }
          })
          .catch(err => {})
      }
      // localStorage.setItem('__ou', JSON.stringify(data))
    },

    sayHiToMember() {},

    addVirtualDocToCircle(user, type) {
      UserRepository.addVirtualDocToCircle(user, this.currentCircle.id, type)
        .then(res => {
          this.$notification.success({ message: "Success", description: res.data.message })
        })
        .catch(err => {
          this.$notification.info({ message: "Information", description: err.response.data.message })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.sub-dailog {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #33415f;
}

.dailog {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #33415f;
}

.dailog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
  // height: 115px;
}

.dailogbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  // height: 163px;
  background: #f1f5f9;
  border-radius: 8px;
}

// .claim-card {
//   border: 1px solid #ccc;
//   width: 100%;
//   background: #fff;
//   border-radius: 8px;
//   box-shadow: 0 0 15px rgba(0,0,0,0.1);
//   .user-name {

//     .bg-img {
//       position: relative;
//       // border: 1px solid #ccc;
//       width: 100px;
//       height: 100px;
//       border-radius: 50%;
//       display: inline-block;
//       img {
//         width: 100%;
//         height: 100%;
//         border-radius: 50%;
//       }
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/commons/profile/circle/SelfProviders.vue